import { IconProps } from './IconProps';

import IconSvg from '../../components/svg-icon/IconSvg';

export const ErrorIcon = (props: IconProps) => {
  return (
    <IconSvg {...props} data-testid="error-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
      />
    </IconSvg>
  );
};
